import { LitheFC } from '@wheelbox/lithejs-engine';

import { createId } from '../../../utils';
import { LoadingIndicatorSize } from './types';

type LoadingIndicatorProps = {
  size?: LoadingIndicatorSize;
};

const LoadingIndicator: LitheFC<LoadingIndicatorProps> = ({
  id = createId(),
  testId = 'loading-indicator',
  size = 'large',
}) => [
  'div',
  {
    id,
    'data-testid': testId,
    class: ['loading-indicator', `loading-indicator--${size}`],
  },
  [
    'div',
    { class: ['loading-indicator__item', `loading-indicator__item--${size}`] },
  ],
  [
    'div',
    { class: ['loading-indicator__item', `loading-indicator__item--${size}`] },
  ],
  [
    'div',
    { class: ['loading-indicator__item', `loading-indicator__item--${size}`] },
  ],
  [
    'div',
    { class: ['loading-indicator__item', `loading-indicator__item--${size}`] },
  ],
];

export default LoadingIndicator;
